import type { ConnectedFacility } from '../../../../../js/api/models/ConnectedFacility';

type Props = {
  connectionsPendingProviderResponse: ConnectedFacility[];
};

export function ConnectionsPendingProviderResponse({ connectionsPendingProviderResponse }: Props) {
  if (connectionsPendingProviderResponse.length === 0) {
    return null;
  }

  if (connectionsPendingProviderResponse.length > 1) {
    const handleClick = () => {
      window.location.href = '/app/provider/connection-requests';
    };

    return (
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
        className="tw:bg-white tw:rounded-xl tw:p-4 tw:border tw:border-gray-200 hover:tw:bg-gray-50 tw:transition-colors tw:cursor-pointer"
      >
        <div className="tw:flex tw:items-start tw:gap-3">
          <div className="tw:sm:w-10 tw:sm:h-10 tw:w-15 tw:h-10 tw:bg-brand-green-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <i className="fa-solid fa-handshake tw:text-white" />
          </div>
          <div className="tw:flex-col">
            <div className="tw:font-medium">New Connection Requests</div>
            <div className="tw:text-sm">
              You have {connectionsPendingProviderResponse.length} pending connection requests
              awaiting your response
            </div>
          </div>
        </div>
      </div>
    );
  }

  const connection = connectionsPendingProviderResponse[0];
  const facilityName =
    connection.facility?.name || connection.healthcare_entity?.name || 'Unknown Facility';

  const handleClick = () => {
    window.location.href = `/app/provider/connection-requests/${connection.id}`;
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      onClick={handleClick}
      className="tw:bg-white tw:rounded-xl tw:p-4 tw:border tw:border-gray-200 hover:tw:bg-gray-50 tw:transition-colors tw:cursor-pointer"
    >
      <div className="tw:flex tw:items-start tw:gap-3">
        <div className="tw:w-10 tw:h-10 tw:bg-brand-green-0 tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <i className="fa-solid fa-handshake tw:text-white" />
        </div>
        <div className="tw:flex-col">
          <div className="tw:font-medium">New Connection Request</div>
          <div className="tw:text-sm">{facilityName} wants to connect.</div>
        </div>
      </div>
    </div>
  );
}

export default ConnectionsPendingProviderResponse;
